import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';
import { sys } from '../sys';

interface TimeBoxChangeTouchDelegate {
  (val: Date): void;
}

@Component({
  selector: 'datex-common-timebox',
  templateUrl: './timebox.component.html',
  styleUrls: ['./timebox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimeboxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class TimeboxComponent implements ControlValueAccessor {
  @Input() readOnly: boolean;
  disabled: boolean;

  momentValue: moment.Moment = moment.utc(0);
  dateValue: Date = null;

  onValueChanged(value: moment.Moment) {
    this.value = value.toDate();
  }

  isDefinedTrimmed(value) {
    return sys.isDefinedTrimmed(value);
  }

  onChange: TimeBoxChangeTouchDelegate = () => void 0;
  onTouch: TimeBoxChangeTouchDelegate = () => void 0;

  get value(): Date {
    return this.dateValue;
  }

  set value(val: Date) {
    this.dateValue = val;
    this.onChange(val);
    this.onTouch(val);
  }

  writeValue(value: unknown): void {
    if (value) {
      this.momentValue = moment.utc(value);
    } else {
      this.momentValue = moment.utc(0);
    }
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: TimeBoxChangeTouchDelegate): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: TimeBoxChangeTouchDelegate): void {
    this.onTouch = fn;
  }
}
